var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tinybox',{attrs:{"images":_vm.computedImages},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}})}
var staticRenderFns = []

export { render, staticRenderFns }